/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Your_Keys_DescriptionInputs */

const en_settings_apikeys_your_keys_description = /** @type {(inputs: Settings_Apikeys_Your_Keys_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use these keys to authenticate API requests`)
};

/**
* | output |
* | --- |
* | "Use these keys to authenticate API requests" |
*
* @param {Settings_Apikeys_Your_Keys_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_your_keys_description = /** @type {((inputs?: Settings_Apikeys_Your_Keys_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Your_Keys_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_your_keys_description(inputs)
});
export { settings_apikeys_your_keys_description as "settings.apikeys.your_keys_description" }